var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1617006240027,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2567,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M590.769231 846.769231c0 19.692308 17.723077 39.384615 39.384615 39.384615h78.769231c21.661538 0 39.384615-21.661538 39.384615-39.384615V177.230769c0-19.692308-17.723077-39.384615-39.384615-39.384615h-78.769231c-21.661538 0-39.384615 21.661538-39.384615 39.384615v669.538462z m-315.076923 0c0 19.692308 17.723077 39.384615 39.384615 39.384615h78.769231c21.661538 0 39.384615-21.661538 39.384615-39.384615V177.230769c0-19.692308-17.723077-39.384615-39.384615-39.384615h-78.769231c-21.661538 0-39.384615 21.661538-39.384615 39.384615v669.538462z",
    "p-id": 2568
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPause);
export default __webpack_public_path__ + "static/media/icon-pause.30000c0d8385d8949d01bd97fe54c50e.svg";
export { ForwardRef as ReactComponent };